///<reference path="../common/smart-mover.models.ts"/>
///<reference path="../common/data-template-security.ts"/>
///<reference path="../../../common/security.keys.ts"/>
///<reference path="../filter-templates/terminated.filter.ts"/>
///<reference path="../filter-templates/logged-in-employee-only.filter.ts"/>
///<reference path="../collections/report-employees.collection.ts"/>


module Meevo.Components.Controls.SmartMover {

    import Dictionary = _.Dictionary;
    import SecurityKeys = Meevo.Components.Common.SecurityKeys;

    export class ReportSecureEmployeeDataTemplate extends DataTemplateSecurity implements ISecureDataTemplate {

        private loggedInUserId: string;

        protected employees: ReportEmployeesCollection;

        public allSelectedSecurityKey: SecurityKeys;
        public securityErrorMessage: string;
        public title: string;
        public allSelectedLabel: string;

        get collection(): ICollectionBase<any> {
            return this.employees;
        }

        /**
         *
         * @param model
         * @param properties - [employeeIds]
         * @param options
         */
        constructor(model: Dictionary<any>, properties: string[], options: IDataTemplateOptions) {
            super(model, properties, options.criteria);

            this.loggedInUserId = options.loggedInUserId;
            this.title = 'LABEL_EMPLOYEE';
            this.allSelectedLabel = 'LABEL_ALL_EMPLOYEES_UPPER';
            this.totalSelectedMessage = 'LABEL_TOTAL_EMPLOYEES_SELECTED';
            this.securityErrorMessage = 'LABEL_REPORT_FOR_LOGGED_IN_USER';
            this.allSelectedSecurityKey = SecurityKeys.REPORTS_VIEWALLEMPLOYEES_EDIT;
            this.employees = new ReportEmployeesCollection(this.model[this.properties[0]], [], {
                criteria: options.criteria,
                smartMoverHidden: () => this.smartMoverHidden,
                hiddenValue: options.hiddenValue !== null ? options.hiddenValue : SmartMoverHiddenValue.EmptyArray
            });
        }

        setWatchers(scope: angular.IScope) {
            scope.$watch(() => this.employees.responseList, (newValue: any) => {
                if (newValue.length > 0) {
                    this.model['dataLoaded'] = true;
                }
            });

            this.employees.setWatchers(scope);
        }

        onSecurityFail() {
            this.showAllSelected = false;
            this.employees.addFilters(new LoggedInEmployeeOnlyFilter({loggedInUserId: this.loggedInUserId}));
            this.onHideToggle(false);
        }

        onHideToggle(hidden: boolean): void {
            if (this.securityFailed) {
                return;
            }

            this.smartMoverHidden = hidden;
        }
    }
}
